// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper {
  margin-top: 10px;
  max-width: 390px;
}

.swiper-slide {
  width: 85%;
}

.swiper-slide:nth-child(2n) {
  width: 85%;
}

.swiper-slide:nth-child(3n) {
  width: 85%;
}


.product-slider .swiper-slide:nth-child(1n) {
  width: 75%;
}

.product-slider .swiper-slide:nth-child(3n) {
  width: 75%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Analysis/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".swiper {\n  margin-top: 10px;\n  max-width: 390px;\n}\n\n.swiper-slide {\n  width: 85%;\n}\n\n.swiper-slide:nth-child(2n) {\n  width: 85%;\n}\n\n.swiper-slide:nth-child(3n) {\n  width: 85%;\n}\n\n\n.product-slider .swiper-slide:nth-child(1n) {\n  width: 75%;\n}\n\n.product-slider .swiper-slide:nth-child(3n) {\n  width: 75%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
